<template>
  <div class="m-pagination-secondary">
    <ul
      v-show="pagination.totalPages > 1"
      class="m-pagination-secondary-pages"
    >
      <li>
        <a
          :class="pagination.currentPage === 1 ? 'page-disabled' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(1)"
        >
          <i class="far fa-chevron-double-left"></i>
        </a>
      </li>
      <li>
        <a
          :class="pagination.currentPage === 1 ? 'page-disabled' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(pagination.currentPage - 1)"
        >
          <i class="far fa-chevron-left"></i>
        </a>
      </li>
      <li
        v-for="(page, index) in visiblePages"
        :key="index"
      >
        <a
          :class="page === pagination.currentPage ? 'page-active' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(page)"
        >
          {{ page }}
        </a>
      </li>
      <li>
        <a
          :class="pagination.currentPage === pagination.totalPages ? 'page-disabled' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(pagination.currentPage + 1)"
        >
          <i class="far fa-chevron-right"></i>
        </a>
      </li>
      <li>
        <a
          :class="pagination.currentPage === pagination.totalPages ? 'page-disabled' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(pagination.totalPages)"
        >
          <i class="far fa-chevron-double-right"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculePaginationSecondary',

  props: {
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        limit: 10,
        showLoadingState: false,
        totalPages: 0
      })
    }
  },

  data () {
    return {
      pagesCutOff: 3,
      visiblePages: []
    }
  },

  watch: {
    'pagination.currentPage': {
      handler () {
        this.setVisiblePages()
      },

      immediate: true
    },

    'pagination.showLoadingState': {
      handler () {
        this.pagination.showLoadingState
          ? this.$alerts.pushAlert('mPaginationSecondary', 'showLoadingState', 'loading', 'a-alert-loading')
          : this.$alerts.closeAlert()
      },

      immediate: true
    }
  },

  methods: {
    setPaginationCurrentPage (page) {
      if (this.pagination.currentPage !== page &&
        page <= this.pagination.totalPages &&
        page >= 1) {
        this.$emit('setPaginationCurrentPage', page)
      }
    },

    setVisiblePages () {
      if (this.pagesCutOff > this.pagination.totalPages) {
        this.visiblePages = Array.from(new Array(this.pagination.totalPages),
          (val, index) => index + 1)
      } else if (this.pagination.currentPage <= this.pagesCutOff) {
        this.visiblePages = Array.from(new Array(this.pagesCutOff),
          (val, index) => index + 1)
      } else if (this.pagination.currentPage >= this.pagination.totalPages - this.pagesCutOff + 1) {
        this.visiblePages = Array.from(new Array(this.pagesCutOff),
          (val, index) => this.pagination.totalPages - this.pagesCutOff + 1 + index)
      } else {
        this.visiblePages = Array.from(new Array(this.pagesCutOff),
          (val, index) => this.pagination.currentPage - parseInt(this.pagesCutOff / 2) + index)
      }
    }
  }
}
</script>
